<template>
  <autocomplete
    item-value="id"
    item-text="nome"
    :items="items"
    :loading="loading"
    :value="value"
    :no-data-text="$t('errori.vuoto')"
    v-bind="$attrs"
    v-on="$listeners"/>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ConvenzioniSelect',
    props: {
        value: { required: false }
    },
    created () {
        this.$store.dispatch('loadConvenzioni').catch(e => {
            this.$snackbar.showServerError(e)
        })
    },
    computed: {
        ...mapState({
            items: state => state.global.convenzioni,
            loading: state => state.global.loading.convenzioni
        })
    }
}
</script>
